import { CustomTooltip, IconButton } from '@fountain/fountain-ui-components';
import { Grid, Typography } from '@material-ui/core';
import { VerifiedUser } from '@material-ui/icons';
import cx from 'classnames';
import omit from 'lodash/omit';
import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  useFormBuilderContextState,
  useQuestionDrawerContextState,
} from '../context';
import { STANDARD_QUESTION_VALUES } from '../QuestionTypeForms/CommonQuestions/constants';
import { isTextDataField } from '../QuestionTypeForms/TextField/helpers';
import { ReviewStageDataFieldTypeEnum } from '../schemas';
import {
  useFieldEnhancementOptionsApiContext,
  useFieldEnhancementOptionsContextState,
} from './context';
import { fieldEnhancementOptionsMessages } from './messages';
import { useTextFieldQuestionFormStyles } from './styles';

export const FieldEnhancementOptions = () => {
  const { applyRegexValidation } = useFieldEnhancementOptionsContextState();
  const { toggleEnhancement, setApplyRegexValidationEnabled } =
    useFieldEnhancementOptionsApiContext();
  const { values, handleChange } = useFormBuilderContextState();
  const { isEdit } = useQuestionDrawerContextState();

  const intl = useIntl();
  const classes = useTextFieldQuestionFormStyles();

  const isApplyRegexValidationDisabled =
    (STANDARD_QUESTION_VALUES as Array<string>).includes(values.key) ||
    values.type !== ReviewStageDataFieldTypeEnum.text_field;

  const applyRegexValidationTooltipMsg = isApplyRegexValidationDisabled
    ? fieldEnhancementOptionsMessages.applyRegexValidationButtonDisabledTooltip
    : applyRegexValidation
      ? fieldEnhancementOptionsMessages.applyRegexValidationEnabledTooltip
      : fieldEnhancementOptionsMessages.applyRegexValidationDisabledTooltip;

  useEffect(() => {
    if (
      isTextDataField(values) &&
      isEdit &&
      (values.format || values.format_validation_message)
    ) {
      setApplyRegexValidationEnabled();
    }
  }, [isEdit, setApplyRegexValidationEnabled, values]);

  return (
    <Grid item xs={12}>
      <div className={classes.container}>
        <Typography className={classes.header}>
          <FormattedMessage {...fieldEnhancementOptionsMessages.header} />
        </Typography>
        <CustomTooltip
          title={intl.formatMessage(applyRegexValidationTooltipMsg)}
          dense
        >
          <IconButton
            aria-label="toggle validation"
            className={cx(classes.validationIconButton, {
              [classes.validationIconButtonEnabled]: applyRegexValidation,
            })}
            onClick={() => {
              if (applyRegexValidation) {
                handleChange(
                  omit(values, ['format', 'format_validation_message']),
                  { replace: true },
                );
              }
              toggleEnhancement('applyRegexValidation');
            }}
            disabled={isApplyRegexValidationDisabled}
          >
            <VerifiedUser
              fontSize="small"
              className={
                applyRegexValidation ? classes.validationIconEnabled : ''
              }
            />
          </IconButton>
        </CustomTooltip>
      </div>
    </Grid>
  );
};
